import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-out-doors',
    templateUrl: './icon-out-doors.component.html'
})
export class IconOutDoorsComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
